import { render, staticRenderFns } from "./ArticleTopHeadlinesSection.vue?vue&type=template&id=3853fd76&scoped=true&"
import script from "./ArticleTopHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleTopHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTopHeadlinesSection.vue?vue&type=style&index=0&id=3853fd76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853fd76",
  null
  
)

export default component.exports